import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>Developing a vision into practical activities can bring a
                                                strategy to life and help to gain buy-in
                                                from those people responsible for making the idea a success.
                                                This tool is all about<span className="brown brownbold"> how to
		communicate visions into actions for others</span> and will help you to think about ways of framing
                                                and communicating visions clearly to enable others to carry out
                                                practical actions and tasks.</p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>3-STEP MODEL: TRANSLATING VISIONS INTO ACTIONS
                                            </div>
                                            <p>You know the feeling? Maybe you had a great idea during the
                                                weekend, which you knew could
                                                really boost sales or solve some long running problem in the
                                                office. You could see it clearly,
                                                couldn't stop thinking about why no one else had come up with or
                                                understood it. So, on Monday,
                                                you approached the commercial director on her way out to lunch
                                                and ran it past her. She hasn't
                                                got back to you yet. When you put the idea to your team, it
                                                didn't come out the way it sounds in
                                                your head, somehow, but you're waiting to see what they come up
                                                with, after they've thought
                                                about it. You're feeling a bit crestfallen, even doubtful,
                                                maybe.</p>
                                            <p>And so your vision lists, capsizes and sinks. This tool will help
                                                to make sure that next time, it'll be
                                                different. There are three separate stages to translating ideas
                                                into realities: Describing and
                                                communicating them effectively, winning other people's
                                                commitment and demonstrating what
                                                definitive action needs to be taken, and by whom. We can boil
                                                this down to Prepare, Explain and
                                                Ask or PEA for short.</p>

                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/PEA_img.png')}
                                                    alt=""/>
                                            </div>

                                            <div className="border_subtitle">Step 1 – Prepare</div>
                                            <p>Two key aspects of preparing to communicate your vision relate to
                                                personality and the context
                                                and task.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading greennumberroundbg1">
                                                <p>Personality – change oriented (big picture) or traditional
                                                    (practical)?</p>
                                            </div>
                                            <p>You've got the idea, now comes the first, practical stage –
                                                thinking about the kind of people
                                                you're going to ‘sell’ it to, the situation or context it would
                                                apply to, and what it would involve,
                                                practically. This way, you can anticipate the kind of questions
                                                different people might ask and what
                                                will interest them the most.</p>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}